import { Component } from "@angular/core";
import { CatalogService } from "../../services/catalog.service";
import { Catalog, Page, Element } from "@app/data/catalog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Listing } from "@app/data/listing";

import { ItemListing, ListingCartItem } from "shopping/cart";
import { UntypedFormControl } from "@angular/forms";
import * as _ from "underscore";
import { fadeInOutAnimation } from "@app/animations";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import { UserService } from "@app/services/user.service";
import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { ViewChild } from "@angular/core";
import { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { User } from "@app/data/user";
import { DigitalOrderSheet } from "@app/data/digital-order-sheet";
import { DigitalOrderSheetService } from "@app/services/digital-order-sheet.service";
import { WindowService } from "@app/services/window.service";
import { debounceTime } from "rxjs";
import { CartService } from "shopping/cart.service";

class Customer {
  public email: String;
  public firstName: String;
  public lastName: String;
  public addressFirstLine: String;
  public addressSecondLine: String;
  public provinceState: String;
  public country: String;
}

@Pipe({
  name: "optimalImage",
})
export class OptimalImagePipe implements PipeTransform {
  transform(image: any): String {
    if (typeof image === "string" || image instanceof String) {
      return image;
    }
    return image.compressed || image.original;
  }
}

@Component({
  templateUrl: "./digital-order-sheet.view.component.html",
  animations: [fadeInOutAnimation],
})
export class DigitalOrderSheetViewComponent {
  @ViewChild("supermodalHasExpired") supermodalHasExpired: SupermodalComponent;

  showBulkPrices: boolean = false;
  showOptionPrices: boolean = false;
  keywords: string = "";
  cartSize: number = 0;
  currentListing: ItemListing;
  customer: Customer;
  catalog: Catalog;
  digitalOrderSheet: DigitalOrderSheet;
  listings: ItemListing[] = [];
  filteredListings: ItemListing[] = [];
  keywordsFormControl = new UntypedFormControl();
  categories: string[] = [];
  selectedCategory: string = "";
  displayedImage: string = "";
  isFromCatalog: boolean = true;
  showAsGrid: boolean = false;

  constructor(
    private windowService: WindowService,
    private router: Router,
    private route: ActivatedRoute,
    private catalogService: CatalogService,
    private digitalOrderSheetService: DigitalOrderSheetService,
    private userService: UserService,
    private cartService: CartService<ListingCartItem>
  ) {
    this.refreshCartSize();
    let data = localStorage.getItem("digital-order-sheet:showAsGrid");
    this.showAsGrid = data ? JSON.parse(data) : false;
  }
  refreshCartSize() {
    this.cartSize = this.cartService.getItems().length;
  }

  showGrid(showAsGrid: boolean) {
    this.showAsGrid = showAsGrid;
    localStorage.setItem("digital-order-sheet:showAsGrid", String(showAsGrid));
  }

  ngAfterViewInit(): void {
    this.cartService.onChange.subscribe((item) => this.refreshCartSize());
    let id = this.route.snapshot.params["id"];
    this.route.data.subscribe((data) => {
      let source = data.source;
      if (source === "catalog") {
        this.isFromCatalog = true;
        this.catalogService.getCatalog(id).then((catalog) => {
          console.log(">>>>> catalog-order-sheet user", catalog.user);
          this.catalog = catalog;
          this.cartService.setLocaleFormat(
            this.catalog.user.iso_currency_code || "USD"
          );
          tearSheetUtils.initListingsCategories(catalog);
          this.initListings(
            this.catalog.categories,
            this.catalog.listings,
            this.catalog.user
          );
        });
      } else if (source === "online store") {
        this.isFromCatalog = false;
        this.digitalOrderSheetService.get(id).then((digitalOrderSheet) => {
          console.log(">>>>> catalog-order-sheet user", digitalOrderSheet.user);
          this.digitalOrderSheet = digitalOrderSheet;
          this.cartService.setLocaleFormat(
            this.digitalOrderSheet.user.iso_currency_code || "USD"
          );
          this.initListings(
            _.uniq(_.pluck(this.digitalOrderSheet.listings, "category")),
            this.digitalOrderSheet.listings,
            this.digitalOrderSheet.user
          );
        });
      }
    });
    this.keywordsFormControl.valueChanges
      .pipe(
        debounceTime(50) // Apply debounceTime using pipe
      )
      .subscribe((newValue) => {
        this.keywords = newValue;
        this.filter();
      });
  }

  initListings(categories: string[], listings: ItemListing[], user: User) {
    //init listings for purchase
    listings.forEach((listing) => {
      listing.quantity = 0;
      listing.bulk_prices = listing.bulk_prices || [];
      if (listing.variations) {
        listing.variations.forEach((variation) => {
          variation.options.forEach((option) => {
            option.quantity = 0;
          });
        });
      }
    });
    this.listings = listings;
    this.categories = categories;
    this.categories.sort(function (a, b) {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    this.filteredListings = _.sortBy(this.listings, "title");
    this.userService.hasExpired(user._id).then((hasExpired) => {
      if (hasExpired) {
        this.supermodalHasExpired.open();
      }
    });
  }

  filter() {
    this.filteredListings = _.sortBy(
      _.filter(this.listings, (listing) => {
        return (
          (listing.title.toLowerCase().indexOf(this.keywords.toLowerCase()) >
            -1 ||
            listing.description
              .toLowerCase()
              .indexOf(this.keywords.toLowerCase()) > -1) &&
          (this.selectedCategory.length == 0 ||
            listing.category == this.selectedCategory)
        );
      }),
      "title"
    );
  }

  increaseQuantity(option) {
    option.quantity++;
  }

  viewDetails(listing: ItemListing) {
    this.currentListing = listing;
    this.showBulkPrices =
      this.currentListing.bulk_prices &&
      this.currentListing.bulk_prices.length > 0;
    this.displayedImage = this.currentListing.main_image;

    this.showOptionPrices = true;
    this.currentListing.variations.forEach((variation) => {
      variation.options.forEach((option) => {
        this.showOptionPrices =
          this.showOptionPrices && option.price !== this.currentListing.price;
      });
    });
  }

  switchDisplayedImage(image: string) {
    this.displayedImage = image;
  }

  hideSidePanels() {
    // this.categoriesDisplayed = false;
    this.currentListing = null;
  }

  decreaseQuantity(option) {
    option.quantity--;
  }

  hashCode(value: String) {
    var hash = 0,
      i,
      chr;
    if (value.length === 0) return hash;
    for (i = 0; i < value.length; i++) {
      chr = value.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  addToCart(
    itemListing: ItemListing,
    quantity: number,
    price: number,
    variation?,
    option?
  ) {
    let id = itemListing.id;
    if (variation && option) {
      if (variation.id) {
        id += `-${variation.id}`;
      } else if (variation.title) {
        id += `-${this.hashCode(variation.title)}`;
      }

      if (option.id) {
        id += `-${option.id}`;
      } else {
        id += `-${this.hashCode(option.title)}`;
      }
    }
    let listingCartItem = new ListingCartItem({
      id,
      itemListing,
      quantity,
      price,
      variation,
      option,
    });
    this.cartService.addItem(listingCartItem);
  }

  emptyCart() {
    this.cartService.clear();
  }

  completeOrder() {}

  getBulkPrice(listing, bulk_price) {
    switch (bulk_price.type) {
      case "price_discount":
        return `${new Intl.NumberFormat(navigator.language, {
          style: "currency",
          currency: listing.iso_currency_code || "USD",
        }).format(bulk_price.amount)} OFF`;
      case "percentage_discount":
        return `${bulk_price.amount}% OFF`;
      case "fixed_price":
        return new Intl.NumberFormat(navigator.language, {
          style: "currency",
          currency: listing.iso_currency_code || "USD",
        }).format(bulk_price.amount);
    }
  }

  addListingToCart(listing) {
    if (listing.quantity > 0) {
      this.addToCart(listing, listing.quantity, listing.price);
      listing.quantity = 0;
    } else if (listing.variations.length === 0) {
      this.addToCart(listing, 1, listing.price);
    }
    listing.variations.forEach((variation) => {
      variation.options.forEach((option) => {
        if (option.quantity > 0) {
          this.addToCart(
            listing,
            option.quantity,
            option.price || listing.price,
            variation,
            option
          );
          option.quantity = 0;
        }
      });
    });
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
    this.filter();
  }

  openCart() {
    if (this.isFromCatalog) {
      this.router.navigate([
        `/catalogs/${this.catalog._id}/order-sheet/shopping-cart`,
      ]);
    } else {
      this.router.navigate([
        `/digital-order-sheets/${this.digitalOrderSheet._id}/shopping-cart`,
      ]);
    }
  }
  moveToHomePage() {
    window.location.href = "/";
  }
}
